module.exports = __webpack_public_path__ + "img/4.a28fb923.svg";